module.exports = __webpack_public_path__ + "static/media/cyptro.eae8fada.jpeg";